import {
  GET_ASSET_URL_FAILURE,
  GET_ASSET_URL_REQUEST,
  GET_ASSET_URL_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';

export const getAssetUrl = (dispatch, data) =>
  dispatch({
    type: GET_ASSET_URL_REQUEST,
    payload: apiClient.asset.getAssetUrl(data).then(
      (res) =>
        dispatch({
          type: GET_ASSET_URL_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_ASSET_URL_FAILURE,
          err,
        }),
    ),
  });

export const validateAssetUrl = (url) =>
  apiClient.asset
    .getAssetMeta(url)
    .then(() => true)
    .catch(() => false);
